import { apiClient } from '@/shared/lib/api'
import type {
  AccessTokenResponse,
  CreateAccessTokenRequest,
  CreateAccessTokenResponse,
  UpdateGiftCardProfileRequest,
  UpdateGiftCardProfileResponse,
} from './types'

export async function fetchAccessTokens(
  limit?: number,
  offset?: number
): Promise<AccessTokenResponse[]> {
  const searchParams = new URLSearchParams()
  if (limit !== undefined) searchParams.set('limit', String(limit))
  if (offset !== undefined) searchParams.set('offset', String(offset))

  const query = searchParams.toString()
  const endpoint = query ? `/users/me/access-tokens?${query}` : '/users/me/access-tokens'

  const data = await apiClient(endpoint)
  return Array.isArray(data) ? data : []
}

export async function createAccessToken(
  request: CreateAccessTokenRequest
): Promise<CreateAccessTokenResponse> {
  return apiClient('/users/me/access-tokens', {
    method: 'POST',
    body: JSON.stringify(request),
  })
}

export async function revokeAccessToken(id: number): Promise<void> {
  await apiClient(`/users/me/access-tokens/${id}`, {
    method: 'DELETE',
  })
}

export async function setPreferredCountry(countryCode: string | null): Promise<void> {
  await updateGiftCardProfile({ prefCountry: countryCode })
}

export async function updateGiftCardProfile(
  request: UpdateGiftCardProfileRequest
): Promise<UpdateGiftCardProfileResponse> {
  return apiClient('/users/me', {
    method: 'POST',
    body: JSON.stringify(request),
  })
}
